import { Divider, Flex } from "@chakra-ui/react";
import { PageLayoutSelector } from "./PageLayoutSelector";
import { PageSizingSelector } from "./PageSizingSelector";
import { P2PReadingSettings } from "./P2PReadingSettings";
import { SlideInHeader } from "../../../../components/slideInMenu/components/SlideInHeader";
import { SLIDE_IN_MENUS } from "../../../root/constants";
import { GeneralSettings } from "./GeneralSettings";

export function SettingsMenu({ onCloseMenu }: { onCloseMenu?: () => void }) {
  return (
    <Flex flexDirection="column" height="100%">
      <SlideInHeader
        openMenu={SLIDE_IN_MENUS.settings}
        onCloseMenu={onCloseMenu}
      />
      <Flex
        className="styled-scrollbar"
        p="24px"
        gap="24px"
        width="100%"
        flexGrow={1}
        overflowY="auto"
        flexDirection="column"
      >
        <PageLayoutSelector />
        <GeneralSettings />
        <Divider />
        <PageSizingSelector />
        <Divider />
        <P2PReadingSettings />
      </Flex>
    </Flex>
  );
}
